import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const WithIdSchema = z.object({ _id: objectIdSchema });

export const WithTimestampSchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const createGroupedItemsSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.record(z.string(), z.array(itemSchema));

export const createMappedItemsSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.record(z.string(), itemSchema);
